import React from "react";
import { Phone, MessageCircle, Mail, ArrowUpRight } from "lucide-react";
import { Reveal } from "./primitives";
import { CONTACT } from "../../data/content";
import { openDemoChooser } from "./DemoBookingModal";

const waLink = `https://wa.me/91${CONTACT.whatsapp}`;
const telLink = `tel:+91${CONTACT.phone}`;

export default function DemoCTA() {
  return (
    <section id="contact" className="relative overflow-hidden bg-ajmus-navy py-20 text-white sm:py-28" data-testid="section-contact">
      <div className="pointer-events-none absolute inset-0 grid-dots opacity-[0.06]" aria-hidden="true" />
      <div className="pointer-events-none absolute -left-20 bottom-0 h-[380px] w-[380px] rounded-full bg-health/20 blur-[130px]" aria-hidden="true" />
      <div className="pointer-events-none absolute -right-20 top-0 h-[380px] w-[380px] rounded-full bg-edu/25 blur-[130px]" aria-hidden="true" />

      <div className="relative mx-auto max-w-4xl px-5 text-center sm:px-8">
        <Reveal>
          <h2 className="mx-auto max-w-3xl font-heading text-4xl font-extrabold tracking-tight sm:text-5xl">
            Ready to Simplify Your Organisation&apos;s Operations?
          </h2>
          <p className="mx-auto mt-5 max-w-2xl text-base leading-relaxed text-white/70 sm:text-lg">
            See how AJMUS can connect your teams, processes, information and management reporting
            through one modern platform.
          </p>
        </Reveal>

        <Reveal delay={0.1}>
          <div className="mt-9 flex flex-wrap items-center justify-center gap-3">
            <button
              onClick={openDemoChooser}
              data-testid="cta-schedule-demo"
              className="group inline-flex items-center gap-2 rounded-full bg-white px-7 py-3.5 text-sm font-semibold text-ajmus-navy transition-colors duration-200 hover:bg-white/90"
            >
              Live Demo
              <ArrowUpRight size={17} className="transition-transform duration-200 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
            </button>
            <a
              href={telLink}
              data-testid="cta-contact"
              className="inline-flex items-center gap-2 rounded-full border border-white/20 px-7 py-3.5 text-sm font-semibold text-white transition-colors duration-200 hover:bg-white/10"
            >
              Contact AJMUS
            </a>
          </div>
        </Reveal>

        <Reveal delay={0.18}>
          <div className="mx-auto mt-12 grid max-w-2xl grid-cols-1 gap-3 sm:grid-cols-3">
            <a href={telLink} data-testid="contact-phone" className="flex items-center justify-center gap-2.5 rounded-2xl border border-white/10 bg-white/5 px-4 py-4 transition-colors duration-200 hover:bg-white/10">
              <Phone size={16} className="text-health-soft" />
              <span className="text-sm font-medium text-white/90">{CONTACT.phone}</span>
            </a>
            <a href={waLink} target="_blank" rel="noopener noreferrer" data-testid="contact-whatsapp" className="flex items-center justify-center gap-2.5 rounded-2xl border border-white/10 bg-white/5 px-4 py-4 transition-colors duration-200 hover:bg-white/10">
              <MessageCircle size={16} className="text-health-soft" />
              <span className="text-sm font-medium text-white/90">WhatsApp</span>
            </a>
            <div className="flex items-center justify-center gap-2.5 rounded-2xl border border-white/10 bg-white/5 px-4 py-4">
              <Mail size={16} className="text-health-soft" />
              <span className="text-sm font-medium text-white/90">{CONTACT.email}</span>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
